import { useState } from 'react';
import { Modal, ModalHeader, ModalBody } from '../../../components/ui';
import { AuthModalProps } from '../../../types';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';

export function AuthModal({ isOpen, onClose, initialUserType = 'student' }: AuthModalProps) {
  const [isSignUp, setIsSignUp] = useState(false);
  const [savedEmail, setSavedEmail] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleSignUpSuccess = (email: string) => {
    setSavedEmail(email);
    setShowSuccessMessage(true);
    // Auto-switch to sign in after a delay
    setTimeout(() => {
      setShowSuccessMessage(false);
      setIsSignUp(false);
    }, 3000);
  };

  const handleSignInSuccess = () => {
    onClose();
  };

  const handleSwitchToSignUp = () => {
    setIsSignUp(true);
    setShowSuccessMessage(false);
  };

  const handleSwitchToSignIn = () => {
    setIsSignUp(false);
    setShowSuccessMessage(false);
  };

  const handleClose = () => {
    // Reset state when modal closes
    setIsSignUp(false);
    setShowSuccessMessage(false);
    setSavedEmail('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="md">
      <ModalHeader onClose={handleClose}>
        {isSignUp ? 'Create Account' : 'Welcome Back'}
      </ModalHeader>
      
      <ModalBody>
        {showSuccessMessage ? (
          <div className="text-center py-8">
            <div className="mb-4">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              </div>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Account Created Successfully!</h3>
            <p className="text-sm text-gray-600 mb-4">
              Please check your email ({savedEmail}) to confirm your account before signing in.
            </p>
            <p className="text-xs text-gray-500">
              You'll be automatically redirected to sign in shortly...
            </p>
          </div>
        ) : isSignUp ? (
          <SignUpForm
            onSuccess={handleSignUpSuccess}
            onSwitchToSignIn={handleSwitchToSignIn}
            defaultUserType={initialUserType}
          />
        ) : (
          <SignInForm
            onSuccess={handleSignInSuccess}
            onSwitchToSignUp={handleSwitchToSignUp}
            defaultEmail={savedEmail}
          />
        )}
      </ModalBody>
    </Modal>
  );
} 